import {Icon} from "@iconify/react";
import {keepPreviousData, useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import Content from "../../../components/Content.tsx";
import {icons} from "../../../components/icons.tsx";
import PButton from "../../../components/PButton.tsx";
import Header from "../../../Header.tsx";
import services from "../../../services";
import {Tournament} from "../../../types";
import queryKeys from "../../../utilities/queryKeys.ts";

export const Route = createFileRoute('/_app/ai/')({
    component: RouteComponent,
})

function RouteComponent() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const aiInsightsQuery = useQuery({
        queryKey:        queryKeys.aiInsights(),
        queryFn:         services.aiInsights.index,
        placeholderData: keepPreviousData,
    })
    const aiInsightsStoreMut = useMutation({
        mutationFn: services.aiInsights.store,
        onSuccess:  (result) => {
            navigate({to: `/ai/${result.uid}`})
            queryClient.invalidateQueries({queryKey: queryKeys.aiInsights()})
        }
    })

    function doCreateNew() {
        aiInsightsStoreMut.mutate({});
    }

    return <>
        <Header />

        <Content>
            <div className={"flex justify-end mb-4"}>
                <PButton color="primary" onPress={doCreateNew} startContent={<span className={"light:text-secondary"}>{icons.plus()}</span>}>
                    Add new
                </PButton>
            </div>

            {aiInsightsQuery.data?.map((aiInsight: Tournament | any) => (
                <div
                    key={aiInsight.uid}
                    className={"light:bg-gray-100 dark:bg-neutral-700 rounded-xl mb-2"}
                >
                    <div key={aiInsight.uid} className={"py-1.5 px-4 flex w-full justify-between items-center"}>
                        <div className="flex-1">
                            {aiInsight.title}<br />
                        </div>

                        <PButton className="mr-1 max-sm:min-w-10 max-sm:px-0!" color={"primary"} onPress={() => navigate({to: `/ai/${aiInsight.uid}/`})}>
                            <Icon icon="material-symbols-light:visibility-outline" className="text-2xl" /><span className="max-sm:hidden">open</span>
                        </PButton>
                    </div>
                </div>
            ))}

        </Content>
    </>
}
